//@flow
import * as React from 'react';
import { themr } from 'react-css-themr';
import classnames from 'classnames';
import Dropzone from 'react-dropzone-v3';
import theme from './DragDrop.scss';
import Icon from 'common/components/core/icon';
import {
    DroppedFile,
    UploadStatusEnum,
    type UploadedFileType
} from './DroppedFile';

export type UploadFilesValueType = { files: UploadFilesList };

type UploadFilesList = Array<UploadedFileType>;

type Files = Array<File>;

type Props = {
    theme: Object,
    className: string,
    value: UploadFilesValueType,
    label: string,
    required: boolean,
    placeholder: string,
    dialogStatus: string,
    onChange: () => void,
    onRemoveFile: (fileIndex: number) => void,
    getDropzoneContainer: () => void
};

class DragDrop extends React.PureComponent<Props, void> {
    onDrop = (acceptedFiles: Files, rejectedFiles: Files, event) => {
        const { onChange, value: prevUploadedFiles } = this.props;
        const { files } = prevUploadedFiles;
        let acceptedFilesArray = [];
        acceptedFiles.forEach(file => {
            const acceptedFileObject = {
                file,
                fileStatus: UploadStatusEnum.Initial
            };
            acceptedFilesArray = [...acceptedFilesArray, acceptedFileObject];
        });
        const updatedFiles = { files: [...files, ...acceptedFilesArray] };
        onChange && onChange(updatedFiles, event);
    };

    getDropzoneRef = ref => {
        const { getDropzoneContainer } = this.props;
        getDropzoneContainer && getDropzoneContainer(ref);
    };

    renderFilesFromValue = value => {
        const { theme } = this.props;
        return value.files && value.files.length > 0 ? (
            <div className={theme.fileNames}>
                {this.renderFiles(value.files)}
            </div>
        ) : null;
    };

    renderFiles = files => {
        const { theme, dialogStatus, onRemoveFile } = this.props;
        return files.map((file, fileIndex) => {
            return file ? (
                <DroppedFile
                    key={fileIndex}
                    fileIndex={fileIndex}
                    theme={theme}
                    file={file}
                    dialogStatus={dialogStatus}
                    onRemoveFile={onRemoveFile}
                />
            ) : null;
        });
    };

    render() {
        const {
            theme,
            className,
            value,
            label,
            placeholder,
            required, //eslint-disable-line no-unused-vars
            onChange, //eslint-disable-line no-unused-vars
            onRemoveFile, //eslint-disable-line no-unused-vars
            dialogStatus, //eslint-disable-line no-unused-vars
            ...others
        } = this.props;
        return (
            <div className={classnames(className, theme.dropzoneWrap)}>
                <div className={theme.label}>{label}</div>
                {value ? this.renderFilesFromValue(value) : null}
                <Dropzone
                    {...others}
                    multiple
                    className={theme.dropzone}
                    activeClassName={theme.dropzoneActive}
                    rejectClassName={theme.dropzoneReject}
                    ref={this.getDropzoneRef}
                    onDrop={this.onDrop}
                >
                    <div className={theme.placeholder}>
                        <Icon
                            icon="file-upload"
                            className={theme.fileUploadIcon}
                            theme={theme}
                        />
                        {placeholder}
                    </div>
                </Dropzone>
            </div>
        );
    }
}

const ThemedDragDrop = themr('DragDrop', theme)(DragDrop);
export default ThemedDragDrop;
export { ThemedDragDrop as DragDrop, UploadStatusEnum };
